import * as React from "react";

/*
A Context to keep track of useGlobals keys for consumers to use the right one

e.g. a lot of the quoting functionality is used by policy updates, and we don't want
to update both globals when going through the process. The context is set at a high
level so components underneath can access this Context to use the right key.
*/
const GlobalsContext = React.createContext<string | null>(null);

const useGlobalsContext = () => React.useContext(GlobalsContext);

export { GlobalsContext, useGlobalsContext };
